var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "el-section" },
      [
        _c("emd-container", {
          attrs: {
            title: _vm.seeMore ? _vm.$t("summary") : _vm.$t("summaryDetails"),
            summary: "",
          },
          scopedSlots: _vm._u(
            [
              {
                key: "summary",
                fn: function () {
                  return [
                    _vm.showItems && !_vm.isMobile ? _c("Items") : _vm._e(),
                    _vm.showLink && !_vm.isMobile ? _c("Link") : _vm._e(),
                    _vm.showPayment && !_vm.isMobile ? _c("Payment") : _vm._e(),
                    !_vm.isMobile
                      ? _c("hr", { staticClass: "emd-divider" })
                      : _vm._e(),
                    _c(
                      "div",
                      {
                        staticClass:
                          "emd-container__footer eu-py_4_md eu-px_5_md eu-justify_space-between eu-align-items_center eu-wrap",
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass:
                              "emd-label eu-display_inline-block summary-title",
                          },
                          [_vm._v(_vm._s(_vm.$t("subtotal")))]
                        ),
                        _c(
                          "span",
                          {
                            staticClass:
                              "emd-text _type_caption eu-display_inline-block eu-ml_1 value-label",
                          },
                          [_vm._v(" " + _vm._s(_vm.subtotal) + " ")]
                        ),
                      ]
                    ),
                    _vm.hasShipping
                      ? _c("hr", { staticClass: "emd-divider" })
                      : _vm._e(),
                    _vm.hasShipping
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "emd-container__footer eu-py_4_md eu-px_5_md eu-justify_space-between eu-align-items_center eu-wrap",
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "emd-label eu-display_inline-block summary-title",
                              },
                              [_vm._v(_vm._s(_vm.$t("shipping")))]
                            ),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "emd-text _type_caption eu-display_inline-block eu-ml_1 shipping-label",
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.shippingCurrencyFormat) + " "
                                ),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.hasShipping
                      ? _c("hr", { staticClass: "emd-divider" })
                      : _vm._e(),
                    _vm.hasShipping
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "emd-container__footer eu-py_4_md eu-px_5_md eu-justify_space-between eu-align-items_center eu-wrap",
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "emd-label eu-display_inline-block summary-title",
                              },
                              [_vm._v(_vm._s(_vm.$t("total")))]
                            ),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "emd-text _type_caption eu-display_inline-block eu-ml_1 value-label",
                              },
                              [_vm._v(" " + _vm._s(_vm.total) + " ")]
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                },
                proxy: true,
              },
              !_vm.isMobile
                ? {
                    key: "footer",
                    fn: function () {
                      return [
                        _c("hr", { staticClass: "emd-divider" }),
                        _c(
                          "div",
                          {
                            staticClass:
                              "eu-flex-item eu-basis_12 eu-basis_12_md eu-align_center eu-no-margin_md eu-pa_3 eu-px_3",
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "summary-footer",
                                on: { click: _vm.expandSummary },
                              },
                              [
                                _vm.seeMore
                                  ? _c("i", {
                                      staticClass: "uil uil-angle-down",
                                    })
                                  : _c("i", {
                                      staticClass: "uil uil-angle-up",
                                    }),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.seeMore
                                        ? _vm.$t("seeMoreDetails")
                                        : _vm.$t("seeLessDetails")
                                    )
                                  ),
                                ]),
                              ]
                            ),
                          ]
                        ),
                      ]
                    },
                    proxy: true,
                  }
                : null,
            ],
            null,
            true
          ),
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }